import { z } from "zod";

export const getCustomFieldOptions = {
  input: z.object({ customFieldId: z.string() }),

  output: z.object({
    name: z.string(),
    options: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
